import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaLinkedin,
  FaYoutube,
  FaInstagram,
} from "react-icons/fa";

const FooterContainer = styled.footer`
  width: 100%;
  // background-color: #f5f5f5;
  padding-top: 3rem;
  font-family: "Manrope", sans-serif;
`;

// const NewsletterSection = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   max-width: 100%; // 1200px;
//   margin: 0 auto;
//   padding: 0 2rem 3rem;

//   @media (max-width: 768px) {
//     flex-direction: column;
//     gap: 2rem;
//     text-align: center;
//   }
// `;

// const NewsletterContent = styled.div`
//   max-width: 500px;

//   @media (max-width: 768px) {
//     max-width: 100%;
//   }
// `;

// const NewsletterTitle = styled.h3`
//   font-size: 1.25rem;
//   font-weight: 600;
//   margin-bottom: 0.5rem;
//   color: #000;
// `;

// const NewsletterDescription = styled.p`
//   font-size: 0.875rem;
//   color: #666;
//   line-height: 1.5;
//   margin-bottom: 1.5rem;
// `;

// const SubscriptionForm = styled.form`
//   display: flex;
//   gap: 0.5rem;
//   max-width: 400px;

//   @media (max-width: 480px) {
//     flex-direction: column;
//   }
// `;

// const EmailInput = styled.input`
//   flex: 1;
//   padding: 0.75rem 1rem;
//   border: 1px solid #f3f3f3;
//   border-radius: 10px;
//   font-size: 0.875rem;
//   outline: none;

//   &:focus {
//     border-color: #5575f7;
//   }
// `;

// const SubscribeButton = styled(motion.button)`
//   background-color: #5575f7;
//   color: white;
//   border: none;
//   border-radius: 50px;
//   padding: 0.75rem 1.5rem;
//   font-size: 0.875rem;
//   font-weight: 500;
//   cursor: pointer;
//   white-space: nowrap;

//   &:hover {
//     background-color: #4361ee;
//   }
// `;

// const EnvelopeImage = styled.div`
//   @media (max-width: 768px) {
//     display: none;
//   }
// `;

// const Image = styled.img`
//   width: 300px;
//   opacity: 0.8;
// `;

const BottomFooter = styled.div`
  background-color: #0a0e1f;
  color: white;
  padding: 1rem 2rem;
`;

const FooterContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 100%; // 1200px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const Copyright = styled.div`
  font-size: 0.75rem;
  color: #aaa;
`;

const FooterLinks = styled.div`
  display: flex;
  gap: 1.5rem;
`;

const FooterLink = styled(Link)`
  font-size: 0.75rem;
  color: #aaa;
  text-decoration: none;

  &:hover {
    color: white;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialIcon = styled(motion.a)`
  color: white;
  font-size: 1.25rem;

  &:hover {
    color: #5575f7;
  }
`;

export const Footer: React.FC = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Subscribing email:", email);
    setEmail("");
  };

  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: {
        type: "spring",
        stiffness: 400,
        damping: 10,
      },
    },
    tap: { scale: 0.95 },
  };

  const iconVariants = {
    hover: { y: -3, transition: { duration: 0.2 } },
  };

  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      {/* <NewsletterSection>
        <NewsletterContent>
          <NewsletterTitle>
            Subscribe to our newsletter for exam tips and updates!
          </NewsletterTitle>
          <NewsletterDescription>
            Stay updated with compelling candidature newsletter showcasing the exam tips and
            updates, news, course updates and job listings globally.
          </NewsletterDescription>
          <SubscriptionForm onSubmit={handleSubmit}>
            <EmailInput
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <SubscribeButton
              type="submit"
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
            >
              Subscribe to newsletter
            </SubscribeButton>
          </SubscriptionForm>
        </NewsletterContent>
        <EnvelopeImage>
          <Image src="/assets/envelope.png" alt="Newsletter envelope" />
        </EnvelopeImage>
      </NewsletterSection> */}

      <BottomFooter>
        <FooterContent>
          <Copyright>© Compelling Candidature, {currentYear}</Copyright>

          <FooterLinks>
            <FooterLink to="#">Privacy Policy</FooterLink>
            <FooterLink to="#">Terms of use</FooterLink>
          </FooterLinks>

          <SocialIcons>
            <SocialIcon
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              variants={iconVariants}
              whileHover="hover"
            >
              <FaFacebook />
            </SocialIcon>
            <SocialIcon
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              variants={iconVariants}
              whileHover="hover"
            >
              <FaTwitter />
            </SocialIcon>
            <SocialIcon
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              variants={iconVariants}
              whileHover="hover"
            >
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              variants={iconVariants}
              whileHover="hover"
            >
              <FaYoutube />
            </SocialIcon>
            <SocialIcon
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              variants={iconVariants}
              whileHover="hover"
            >
              <FaInstagram />
            </SocialIcon>
          </SocialIcons>
        </FooterContent>
      </BottomFooter>
    </FooterContainer>
  );
};
